import { createElement } from "react";
import { Icons, IconSetNames } from "@/components/Icons";

export default function IconWrapper(props: any) {
  const { size, iconName }: { size: "s" | "m" | "l" | "xl" | "xxl" | "full", iconName: IconSetNames } = props;

  return createElement(Icons[`${iconName}`], {
    id: `studio-icons-${iconName}`,
    size: size
  });
}
